import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Dashboard from '@/components/Dashboard'
import Home from '@/components/Home'
import Success from '@/components/Success'
import Failed from '@/components/Failed'
import Emailverify from '@/components/Emailverify'
import Reqdemo from '@/components/Reqdemo'
import Democonfirm from '@/components/Democonfirm'
import Test from '@/components/Test'
import VueFractionGrid from 'vue-fraction-grid'
import 'vue-awesome/icons'
import Icon from 'vue-awesome/components/Icon'

Vue.use(Router)
Vue.component('icon', Icon)
Vue.use(VueFractionGrid, {
  container: '1200px',
  gutter: '15px',
  approach: 'desktop-first',
  breakpoints: {
    compact: '480px',
    tablet: '768px',
    web: '960px'
  }
})

// register modal component
Vue.component('modal', {
  template: '#modal-template'
})

export default new Router({
    mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
        path: '/Dashboard',
        name: 'Dashboard',
        component: Dashboard
    },
    {
        path: '/Success',
        name: 'Success',
        component: Success
    },
    {
        path: '/Emailverify',
        name: 'Emailverify',
        component: Emailverify
    },
    {
        path: '/Failed',
        name: 'Failed',
        component: Failed
    },
    {
        path: '/Test',
        name: 'Test',
        component: Test
    },
    {
        path: '/Demo',
        name: 'Reqdemo',
        component: Reqdemo
    }
    ,
    {
        path: '/Democonfirm',
        name: 'Democonfirm',
        component: Democonfirm
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js